// 診断モーダル用
// 診断モーダル表示時に本体の画面位置を保存する変数
let _bodyY = 0;

$(function() {

	// 設問ID
	const ID_QUESTION_AREA = 3;
	const ID_QUESTION_GOAL_LEVEL = 6;
	const ID_QUESTION_PURPOSE = 9;

	// 診断チャット枠の定義
	const shindanChat = $('.js-shindan-chat');

	// 診断モーダルを開く（学年カテゴリ押下時、診断スタート押下時は回答情報をリセットして始めから選択させる）
	$(document).on('click', '.js-shindan-modal-open', function() {
		// 診断の最初の設問・選択肢以外は全て非表示
		$('.js-chat:not(:first)').find('.js-chat-question,.js-chat-answer').hide();
		// 選択状態をリセット
		$('.js-chat').find('input[type=radio]').prop('checked',false);
		toggleShindanChat(true);
	});
	
	// 続きから回答するボタン押下時は回答情報をリセットせず、続き部分（画面の最下部）を表示する
	$(document).on('click', '.js-chat-tsuzuki', function() {
		toggleShindanChat(true);
		$('.js-shindan-chat').scrollTop($('.js-shindan-chat')[0].scrollHeight);
	});

	// 診断モーダルを閉じる（×ボタン）
	$(document).on('click', '.js-shindan-modal-close', function() {
		// 診断モーダルを閉じる時に設問回答済みの場合は「続きから回答する」ボタンを表示する
		if ($('.js-shindan-wrap').find('input[type="radio"]:checked').length > 0) {
			$('.js-chat-tsuzuki').show();
		} else {
			$('.js-chat-tsuzuki').hide();
		}
		toggleShindanChat(false);
	});
	
	// 学年カテゴリ選択
	$(document).on('click','.js-grade-category', function() {
		// 学年の選択肢を非表示
		$('.js-chat-grade').hide();
		let gradeCategory = $(this).data('answer');

		// 学年カテゴリーに該当する学年を表示
		$('.js-grade-box').hide();
		$('.js-grade-box[data-grade-category=' + gradeCategory +']').show();

		// 学年カテゴリーを保存
		$('[name="grade_category"]').val(gradeCategory);
		
		// 学年の選択肢を表示
		$('.js-chat-grade').show('normal', function() {
			shindanChat.animate({scrollTop:shindanChat.scrollTop() + shindanChat.outerHeight()}, 500, "swing");
		});
	});
	
	// ラジオボタン選択
	$(document).on('change','.js-match-answer', function() {
		// 例外処理
		irregularAnswerProcessing($(this));
		// 以降の設問をリセット
		clearAndCloseNextAllQuestions($(this).parents('.js-chat'));
		// こだわり条件チェックボックスの確定ボタン出し分け
		changeStyleConditionsConfirmButton();
		// 次の設問を表示
		showNextQuestion($(this).parents('.js-chat').next('.js-chat'));
	});

	// こだわり条件チェックボックス選択
	$(document).on('change','.js-match-answer-condition-checkbox', function() {
		// 以降の設問をリセット
		clearAndCloseNextAllQuestions($(this).parents('.js-chat'));
		// こだわり条件チェックボックスの確定ボタン出し分け
		changeStyleConditionsConfirmButton();
	});

	/**
	 * こだわり条件チェックボックスの確定ボタン出し分けを行う
	 * チェックボックスが選択されていれば有効ボタン、未選択なら無効ボタンを表示する
	 */
	function changeStyleConditionsConfirmButton(){
		// こだわり条件チェックボックスが一つでもチェックされていれば、チェックボックス確定ボタンを表示
		if($('.js-match-answer-condition-checkbox:checked').length != 0) {
			$('.js-match-answer-condition-checkbox-confirmed').show();
			$('.js-match-answer-condition-checkbox-confirmed-disabled').hide();
		} else {
			$('.js-match-answer-condition-checkbox-confirmed').hide();
			$('.js-match-answer-condition-checkbox-confirmed-disabled').show();
		}
	}

	// こだわり条件チェックボックス確定ボタン
	$(document).on('click','.js-match-answer-condition-checkbox-confirmed', function() {
		// こだわり条件チェックボックスに一つでもチェックがあれば進む
		if($('.js-match-answer-condition-checkbox:checked').length != 0) {
			// 次の設問を表示
			showNextQuestion($(this).parents('.js-chat').next('.js-chat'));
		}
	});

	/**
	 * イレギュラー処理を行う
	 * 特定の設問で選択された回答に応じて後続設問の表示内容を変更する
	 * @param {jQuery} tagerElement 選択されたラジオボタン要素
	 */
	function irregularAnswerProcessing(tagerElement){
		// 設問番号を取得
		let questionId = tagerElement.attr('name');

		if (questionId == ID_QUESTION_PURPOSE) {
			// 目的で選択した選択肢によって、最終目標の設問文を変更
			if(tagerElement.attr('data-special-option-name') == 'jyuken'){
				// 受験を選択した場合、最終目標の設問文はサブテキストを表示
				$('.js-chat[data-question-id=' + ID_QUESTION_GOAL_LEVEL + ']').find('.js-question-text-main').hide();
				$('.js-chat[data-question-id=' + ID_QUESTION_GOAL_LEVEL + ']').find('.js-question-text-sub').show();
			} else {
				// 受験以外を選択した場合、最終目標の設問文はメインテキストを表示
				$('.js-chat[data-question-id=' + ID_QUESTION_GOAL_LEVEL + ']').find('.js-question-text-sub').hide();
				$('.js-chat[data-question-id=' + ID_QUESTION_GOAL_LEVEL + ']').find('.js-question-text-main').show();
			}
		}
	}

	/**
	 * 以降の設問をクリアして閉じる
	 * 指定した設問より後の全ての設問と選択肢を非表示にし、選択状態をリセットする
	 * @param {jQuery} elementTargetJsChat 対象の設問要素
	 */
	function clearAndCloseNextAllQuestions(elementTargetJsChat){		
		elementTargetJsChat.nextAll('.js-chat').find('.js-chat-question,.js-chat-answer').hide();
		elementTargetJsChat.nextAll('.js-chat').find('input[type=radio]').prop('checked',false);
		elementTargetJsChat.nextAll('.js-chat').find('input[type=checkbox]').prop('checked',false);
	}

	/**
	 * 次の設問を表示する
	 * 駅選択エリアの場合は診断結果にリダイレクト、それ以外は次の設問をアニメーション表示する
	 * @param {jQuery} elementNextJsChat 次の設問要素
	 */
	function showNextQuestion(elementNextJsChat){
		if($('.js-match-contents').attr('data-station_cd') && elementNextJsChat.attr("data-question-id") == ID_QUESTION_AREA){
			// 駅を選択したエリアLP4は、エリア選択の設問は飛ばして、診断結果を表示
			redirectMatchResultPage($('.js-match-contents').attr('data-pref_cd'), '', $('.js-match-contents').attr('data-station_cd'), '');
		} else {
			// 次の設問を表示する（チャット形式に見せるためアニメーションで表示）
			elementNextJsChat.find('.js-chat-question').show('normal', function() {
				shindanChat.animate({scrollTop:shindanChat.scrollTop() + shindanChat.outerHeight()}, 500, "swing");
				elementNextJsChat.find('.js-chat-answer').show('normal');	
			});
		}
	}

	// 「郵便番号から探す」を選択
	$('.js-search-by-postal').change(function(){
		// 表示済の設問を非表示にする。郵便番号の設問を削除する。
		$(this).parents('.js-chat').nextAll('.js-chat').find('.js-chat-question,.js-chat-answer').hide();
		$('.js-postal-box').remove();
		showInputZipCd();
	});

	// 「最寄り駅から探す」を選択
	$('.js-search-by-station').change(function(){
		// 表示済の設問を非表示にする。駅選択のテキストボックスを空にする。サジェスト削除。
		let parent = $(this).parents('.js-chat');
		parent.nextAll('.js-chat').find('.js-chat-question,.js-chat-answer').hide();
		$('input[name=search_word]').val('');
		$('.js-suggest-list').remove();
		$('.js-station-text').text('').hide();
		$('.js-station-input').show();
		
		// 次の設問を表示する（チャット形式に見せるためアニメーションで表示）
		parent.nextAll('.js-station').find('.js-chat-question').show('normal', function(){
			shindanChat.animate({scrollTop:shindanChat.scrollTop() + shindanChat.outerHeight()}, 500, "swing");
			parent.nextAll('.js-station').find('.js-chat-answer').show('normal');
		});
	});

	// 郵便番号検索ボタン押下時
	$(document).on('click', ".js-check-postal", function() {
		let parent = $(this).parents('.js-postal-box');
		let zipCd = parent.find('input[name=zip_cd]').val();
		// DBに存在する郵便番号かチェック
		$.ajax({
			type:'POST',
			url:"/iphone/match/ajax_validate_postal/",
			scriptCharset:"UTF-8",
			data: { is_json: 1, validate_data:zipCd}
		}).done(function(res) {
			if (res.validate_result == true && res.city_cd != null && res.pref_cd != null){
				redirectMatchResultPage(res.pref_cd, res.city_cd, '', zipCd);
			} else {
				// 入力文言をテキストボックスからテキストに切り替える
				parent.find('.js-postal-text').text(zipCd).show('normal');
				parent.find('.js-postal-input').remove();
				showInputZipCd(1);
			}
		});
	});

	// 駅サジェスト押下時
	$(document).on('click', ".js-station-suggest", function() {
		redirectMatchResultPage($(this).attr('data-pref_cd'), null, $(this).attr('id'), '');
	});
})

/**
 * 診断結果を取得し診断結果ページに遷移する
 * 選択された回答をパラメータ化してAjaxで診断結果を取得し、結果ページへリダイレクトする
 * @param {string} pref_cd 都道府県コード
 * @param {string} cityCd 市区町村コード
 * @param {string} stationCd 駅コード
 * @param {string} zipCd 郵便番号
 */
function redirectMatchResultPage(pref_cd = '', cityCd = '', stationCd = '', zipCd = '') {
	
	// パラメータmaの作成 指定順序順にパラメータを作成
	let parameterMatchAnswerOrders = $('[name="parameter_match_answer_order"]').val().split(',');
	let matchAnswersStr = '';
	parameterMatchAnswerOrders.forEach((val) => {
		// 立場等のundifinedの場合は1を入れる
		matchAnswersStr += $('[name=' + val + ']:checked').val() === undefined ? 1 : $('[name=' + val + ']:checked').val();
	});

	// パラメータmcの作成 表示順に並べる
	let matchConditions = [];
	$('.js-match-answer-condition-checkbox').each(function() {
		matchConditions.push($(this).prop("checked") ? '1' : '0');
	});
	let matchConditionsStr = matchConditions.join('');

	$.ajax({
		type:'POST',
		url:"/iphone/match/ajax_get_match_result",
		scriptCharset:"UTF-8",
		data:{
			pref_cd : pref_cd,
			city_cd : cityCd,
			station_cd : stationCd,
			grade_category : $('[name="grade_category"]').val(),
			ma : matchAnswersStr,
			mc : matchConditionsStr
		}
	}).done(function(res) {
		
		let base_url = '/iphone/lp4/';
		let paramsStr = 'grade_category=' + res.result.grade_category + '&' + res.result.MatchResult.class_type + '=1&ma=' + res.result.ma + '&mc=' + res.result.mc
		if (res.result.city_cd) {
			// 市区町村
			url = base_url + res.result.city_cd + '.html?' + paramsStr;
			// 郵便番号がある場合はクエリパラメータに付与する
			if (zipCd){
				url += '&z=' + zipCd;
			}
		} else {
			// 駅
			url = base_url + 's' + res.result.station_cd + '.html?' + paramsStr;
		}
		// 都道府県、政令指定都市ページから市区・駅ページの診断結果に遷移した場合は「もう一度診断する」ボタンで元のページに戻れるようにパラメータを付与する
		if ($('.js-match-contents').data('station_cd') == false){
			if ($('.js-match-contents').data('l_city_cd')){
				// 政令指定都市
				url += '&org_area_cd=' + $('.js-match-contents').data('l_city_cd');
			} else if ($('.js-match-contents').data('city_cd')){
				// 市区町村
				url += '&org_area_cd=' + $('.js-match-contents').data('city_cd');
			} else {
				// 都道府県
				url += '&org_area_cd=' + $('.js-match-contents').data('pref_cd');
			}
		}

		// biglpであれば、後ろにフラグパラメータを付与
		if (location.href.indexOf('iphone/biglp') !== -1) url += '&biglp=1';

		// 診断結果を表示
		location.href = url + '#pittari-result';
		return;
	});
}

/**
 * 郵便番号入力フォームを表示する
 * Ajaxで入力フォームを取得して診断チャットに追加する(失敗する場合繰り返し呼ばれるため非同期で実装)
 * @param {number} ngFlg エラー表示フラグ(0:通常, 1:エラー表示)
 */
function showInputZipCd(ngFlg=0) {
	let shindanChat = $('.js-shindan-chat');
	// サーバーサイドからレコメンドを取得
	$.ajax({
		type: "POST",
		url: "/iphone/match/get_input_zip_cd/",
		datatype: 'json',
		data:{
			is_ng:ngFlg
		}
	}).done(function(res) {
		// 郵便番号入力フォームを表示
		$('.js-postal').append(res.response).find('.js-chat-question').show('normal', function() {
			$('.js-postal').find('.js-chat-answer').show('normal');
			shindanChat.animate({scrollTop:shindanChat.scrollTop() + shindanChat.outerHeight()}, 500, "swing");
		});
		trackEvent.bindEventOnElements('.js-postal-input');
	});
}

/**
 * 診断チャットの表示を切り替える
 * 表示時は本体のスクロール位置を保存して固定し、非表示時は元の位置に戻す
 * @param {boolean} displayFlg 表示フラグ(true:表示, false:非表示)
 */
function toggleShindanChat(displayFlg) {
	if (displayFlg) {
		// 現在の表示位置を保持して本体スクロールを無効にする
		_bodyY = $(window).scrollTop();
		$('body').css({position:'fixed', width:'100%'});
		$('.js-shindan-wrap').show();
	} else {
		// 本体スクロールを有効にして元の位置で表示
		$('body').css({overflow:'auto', width:'', height:'', position:''});
		$(window).scrollTop(_bodyY);
		$('.js-shindan-wrap').hide();
	}
}